export type BulkAssetJobType = 'service' | 'clean' | 'job';

/**
 * Task name suffix for bulk-created asset jobs (one task per selected asset).
 * Job titles use a different helper; this is only the per-asset task name.
 */
export function getBulkAssetTaskName(jobType?: BulkAssetJobType): string {
  switch (jobType) {
    case 'service':
      return 'Service';
    case 'clean':
      return 'Clean';
    case 'job':
    default:
      return 'Maintenance';
  }
}
